import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
  CardFooter,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const User: React.FC = () => {
  const { user, logout } = useAuth();

  return (
    <div className="w-full mt-8 px-4">
      <Card>
        <CardHeader>
          <CardTitle>User Page</CardTitle>
          <CardDescription>Accessible to authenticated users</CardDescription>
        </CardHeader>

        <CardContent>
          <p>
            Welcome, <strong>{user?.username}</strong>
          </p>
        </CardContent>

        <CardFooter className="flex items-center justify-between">
          <Button variant="outline" onClick={() => logout()}>
            Logout
          </Button>
          <Button asChild>
            <Link to="/">Home</Link>
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};

export default User;
